module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_prebuilt_themes.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_prebuilt_themes.png
// module id = yGwG
// module chunks = 0